/*
 * Las vistas de la web publica, contadas sin molestar (2026-10-29).
 *
 * En cada cambio de pagina manda UN aviso minimo al servidor —`sendBeacon`: no
 * espera, no bloquea y sobrevive a que se cierre la pestana— con la seccion, el
 * canal y, en la primera vista, de donde viene. No guarda nada en el aparato (ni
 * cookie ni localStorage) ni manda ningun dato personal: el servidor hace un hash
 * del visitante que cambia cada dia, sin guardar la IP.
 *
 * Contar no puede romper una visita: todo va dentro de un try.
 */
const RUTA = `${process.env.VUE_APP_PATH}stats/vista`

const canal = () => {
  try {
    if (sessionStorage.getItem('modoTotem') === '1') return 'totem'
  } catch (e) {
    /* sin sessionStorage: se sigue */
  }

  try {
    if (
      (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
      window.navigator.standalone === true
    ) {
      return 'pwa'
    }
  } catch (e) {
    /* idem */
  }

  return 'web'
}

const anfitrion = (direccion) => {
  try {
    return new URL(direccion).hostname.replace(/^www\./, '')
  } catch (e) {
    return ''
  }
}

export function registrarVistas(router) {
  let primera = true

  router.afterEach((to, from) => {
    try {
      if (!to.name || to.name === 'DevTools') return

      // Solo cambia la consulta o el ancla: es la misma pagina.
      if (from && from.name && from.path === to.path) return

      const cuerpo = {
        s: String(to.name),
        d: String(to.params.experienceCode || to.params.experienceTypeCode || ''),
        k: canal()
      }

      if (primera) {
        const consulta = new URLSearchParams(window.location.search)
        cuerpo.u = (consulta.get('utm_source') || '').slice(0, 40)
        cuerpo.r = anfitrion(document.referrer).slice(0, 80)
        primera = false
      } else {
        cuerpo.i = 1
      }

      const datos = JSON.stringify(cuerpo)

      if (navigator.sendBeacon) {
        navigator.sendBeacon(RUTA, new Blob([datos], { type: 'text/plain' }))
      } else {
        fetch(RUTA, { method: 'POST', body: datos, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(() => {})
      }
    } catch (e) {
      /* contar no puede romper una visita */
    }
  })
}
